module.exports = __webpack_public_path__ + "static/media/3.4df95bc1.jpg";